<template>
  <div>
      <Navbar></Navbar>
      <mdb-container class="main-container d-flex flex-row justify-content-start authenticated-router-view-contaner">
          <router-view />
      </mdb-container>
  </div>
</template>
<script>
import Navbar from '../components/Navbar'
import {mdbContainer} from 'mdbvue'
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'Authenticated',
    components : {
      Navbar,
      mdbContainer
    },

    mounted(){
        this.getCart();
    },
    methods : {
        ...mapActions('CartModule',[
            'getCart'
        ]),

        openNotification(){

        }
    },

  
    computed : {
       /*  ...mapGetters('CartModule',[
            'cart',
        ]) */
    }
    
}
</script>
<style scope lang="scss">
</style>